// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__18duI","options":"AnswerScale_options__29W8D","selected":"AnswerScale_selected__1QxE8"};